import React from 'react';

function NotFound(props) {
  return (
    <div>
      Component not found
    </div>
  );
}

export default NotFound;